import { Form, Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { AutomationFormValues } from "../../helpers/form-values"
import type { AutomationOptions } from "../../types/automation.types"
import { BuilderSection } from "./BuilderSection"

export function SenderSection({
  options,
  complete
}: {
  options: AutomationOptions
  complete: boolean
}) {
  const { t } = useTranslation()
  return (
    <BuilderSection sectionKey={"sender"} complete={complete}>
      <Form.Item<AutomationFormValues>
        label={t("settingsAutomation.builder.sender.label")}
        name={"sender_user"}
        extra={t("settingsAutomation.builder.sender.help")}
        rules={[{ required: true, message: t("settingsAutomation.builder.sender.required") }]}
        className={"mb-0"}
      >
        <Select
          showSearch
          optionFilterProp={"label"}
          placeholder={t("settingsAutomation.builder.sender.placeholder")}
          options={options.senders.map((sender) => ({
            value: sender.id,
            label: `${sender.name} · ${sender.email}`
          }))}
        />
      </Form.Item>
    </BuilderSection>
  )
}
